module.exports = __webpack_public_path__ + "media/images/pic/labels/c1_2-62a9be50efd0839c835a422334f647e7.png";